export default function getValidClinicDays(slots, clinicDays) {
  const slotDates = new Set(slots.map(slot => slot.slotDate));
  return clinicDays.filter(day => slotDates.has(day.date))
}